import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { Tour, TourState, SearchDeviceListQueryParam, TourDevicesPagedResponse } from "./types";
import { CancellableQuery, RootState } from "@/store/types";
import { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";

export const actions: ActionTree<TourState, RootState> = {
	/** Tour Setup */
	async fetchAllTours({ commit }) {
		let { data } = await api.fetchAllTours();

		// Clear out
		commit("setAllTours", []);

		data = data.map(obj => ({ ...obj, functionality: null }));

		if (data.length > 0) {
			commit("setAllTours", data);
		}
	},
	async fetchDeviceList({ commit }, groupID: number) {
		const { data } = await api.fetchDeviceList(groupID);
		commit("setAllDevices", data);
	},
	async searchDeviceList({ commit }, payload: CancellableQuery<SearchDeviceListQueryParam>)
	: Promise<void> {
		const { data } = await api.searchTourDeviceList(payload);
		commit("addSearchDevices", data);
	},
	async removeTour({ commit }, tourId: number) {
		const { data } = await api.deleteTour(tourId);
		if (data) {
			commit("unsetTour", tourId);
		}
	},
	async getMaxCamerasAllowedForArea(context, groupId: number): Promise<number>  {
		return await api.getMaxCamerasAllowedPerVideoTour(groupId);
	},
	async getMissingTourDevices(context, payload: PaginatedSearchRequest)
	: Promise<TourDevicesPagedResponse> {
		return await api.getMissingTourDevices(payload);
	},
	async addTour(context, payload: CancellableQuery<Tour>): Promise<void> {
		return await api.addTour(payload);
	},
	async updateTour(context, payload: CancellableQuery<Tour>): Promise<void> {
		return await api.updateTour(payload);
	},
	triggerActiveCell({ commit }, confirmed: boolean) {
		commit("setTriggeredActiveCell", confirmed);
	},
	triggerStreamingData({ commit }, object: object) {
		commit("setTriggeredIsStreaming", object);
	}
};
